// extracted by mini-css-extract-plugin
export default {"badge":"styles_badge__v08HZ","open":"styles_open__I55TC","close":"styles_close__74QVe","required-astarisk":"styles_required-astarisk__k22ZW"};